import { loadStripe } from '@stripe/stripe-js'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { root } from 'src/utils/mountReactApp'
import parseJSON from 'src/utils/parseJSON'
import StripeWrapper from 'src/widgets/donate_v6/StripeWrapper'
import App from 'src/widgets/donate_v6/sympathy_card/App'
import Plugin from 'src/widgets/donate_v6/sympathy_card/Plugin'

const params = new URLSearchParams(location.search)
const honoreeName = params.get('honoree_name')
const theFamilyOf = `The Family of ${honoreeName}`
const fhDetails = parseJSON(params.get('fh_details'))
const providedAddress = fhDetails && {
  name: fhDetails.FHKnownBy1,
  address: {
    line1: fhDetails.FHAddress1,
    line2: fhDetails.FHAddress2,
    city: fhDetails.FHCity,
    state: fhDetails.FHState,
    postal_code: fhDetails.FHZip,
    country: 'US',
  }
}

root.addEventListener('MountReactApp', e => {
  const { stripeKey, ...props } = e.detail
  const stripePromise = loadStripe(stripeKey)
  createRoot(document.getElementById('SympathyCardRoot')).render(
    <StrictMode>
      <StripeWrapper
        App={App}
        stripePromise={stripePromise}
        stripeKey={stripeKey}
        honoreeName={honoreeName}
        theFamilyOf={theFamilyOf}
        providedAddress={providedAddress}
        {...props}
      />
    </StrictMode>
  )
})

const PluginWrapper = props =>
  <Plugin {...props} honoreeName={honoreeName} />

const detail = {
  hooks: { beforeThankYou: PluginWrapper },
  collectData: 'none',
}

root.dispatchEvent(new CustomEvent('addPlugin', { detail }))
